"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
const react_1 = __importDefault(require("react"));
const PopupWrapper_1 = require("./PopupWrapper");
const className = 'popup';
class Popup extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isOpened: this.props.isOpened || false,
        };
        this.toggleOpen = () => {
            const { onClosePopup } = this.props;
            const updatedIsOpened = !this.state.isOpened;
            this.setState({
                isOpened: updatedIsOpened,
            }, () => !updatedIsOpened && onClosePopup && onClosePopup());
        };
    }
    render() {
        const { button, ButtonComponent, isCloseButtonVisible, modificators } = this.props;
        const { isOpened } = this.state;
        const beforeComponent = ButtonComponent ? react_1.default.createElement(ButtonComponent, { onClick: this.toggleOpen }) : (react_1.default.createElement("div", { onClick: this.toggleOpen, className: `${className}__button`, role: 'button' }, button));
        return (react_1.default.createElement(react_1.default.Fragment, null,
            beforeComponent,
            react_1.default.createElement(PopupWrapper_1.PopupWrapper, { onClose: this.toggleOpen, isCloseButtonVisible: isCloseButtonVisible, isOpened: isOpened, modificators: modificators }, this.props.children)));
    }
}
exports.Popup = Popup;
Popup.defaultProps = {
    onClosePopup: () => {
    },
};
//# sourceMappingURL=index.js.map